/* Gentle lighting on re-entry: >=50% visible to start, fully out to re-arm. */
(() => {
  const tag = 'gdp-season-decor';
  if (customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window) || this.dataset.motion === 'static') return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.ready = () => {
        if (!this.isConnected) return;
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target !== this) continue;
            if (entry.intersectionRatio === 0) delete this.dataset.lit;
            else if (entry.intersectionRatio >= .5 && !this.dataset.lit && !motion.matches) {
              this.dataset.lit = 'true';
            }
          }
        }, { threshold: [0, .5] });
        this.observer.observe(this);
      };
      this.image = this.querySelector('img');
      if (this.image?.complete && this.image.naturalWidth) this.ready();
      else this.image?.addEventListener('load', this.ready, { once: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.image?.removeEventListener('load', this.ready);
      delete this.dataset.lit;
    }
  });
})();
